import { ServiceResponseBase } from '@/app-modules/service-request';
import { UserModel } from '..';

class LoginResponse extends ServiceResponseBase<UserModel> {
}

export { LoginResponse };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/login/_domain/responses/index.ts